import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <div className="tk-container py-20 max-w-md text-center" data-testid="forgot-sent">
        <div className="w-14 h-14 rounded-full bg-emerald-50 mx-auto mb-6 flex items-center justify-center">
          <MailCheck className="text-emerald-600" size={26} />
        </div>
        <h1 className="text-3xl font-semibold mb-3">Sjekk e-posten din</h1>
        <p className="text-slate-600 mb-8 leading-relaxed">
          Hvis denne e-posten er registrert hos oss, vil du motta en e-post innen kort tid.
          Lenken er gyldig i 24 timer.
        </p>
        <Link to="/logg-inn" className="tk-btn-secondary" data-testid="back-to-login">
          Tilbake til innlogging
        </Link>
      </div>
    );
  }

  return (
    <div className="tk-container py-20 max-w-md" data-testid="forgot-page">
      <p className="tk-overline mb-3">Konto</p>
      <h1 className="text-3xl font-semibold mb-3">Glemt passord?</h1>
      <p className="text-sm text-slate-500 mb-8">
        Skriv inn e-postadressen din, så sender vi en lenke til å tilbakestille passordet.
      </p>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-sm font-medium text-slate-700">E-post</label>
          <input
            type="email"
            required
            className="tk-input mt-1"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="forgot-email-input"
          />
        </div>
        <button
          type="submit"
          disabled={busy}
          className="tk-btn-primary w-full justify-center"
          data-testid="forgot-submit-btn"
        >
          {busy ? "Sender …" : "Send tilbakestillingslenke"}
        </button>
      </form>
      <p className="text-sm text-slate-500 mt-6">
        <Link to="/logg-inn" className="underline">Tilbake til innlogging</Link>
      </p>
    </div>
  );
}
